import { createWebHistory, createRouter } from "vue-router";
import axios from "axios";
import baseURL from "@/main";
import md5 from "md5";
import { getHeaders } from "@/composable/getHeaders";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("./views/PageLogin"),
  },
  {
    path: "/",
    name: "home",
    component: () => import("./views/PageHome"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cantieri",
    name: "csite",
    component: () => import("./views/module/cantieri/CantiereList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cantieri/read/:id",
    name: "csite-read",
    component: () => import("./views/module/cantieri/CantiereRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cantieri/update/:id",
    name: "csite-update",
    component: () => import("./views/module/cantieri/CantiereUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cantieri/create",
    name: "csite-create",
    component: () => import("./views/module/cantieri/CantiereCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/impostazioni",
    name: "settings",
    component: () => import("./views/module/impostazioni/ImpostazioniList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/planning",
    name: "planning",
    component: () => import("./views/module/planning/PlanningList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/articoli",
    name: "articles",
    component: () => import("./views/module/articoli/ArticoliList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/articoli/read/:id",
    name: "articles-read",
    component: () => import("./views/module/articoli/ArticoliRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/articoli/update/:id",
    name: "articles-update",
    component: () => import("./views/module/articoli/ArticoliUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/articoli/create",
    name: "articles-create",
    component: () => import("./views/module/articoli/ArticoliCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/moduli",
    name: "modules",
    component: () => import("./views/module/moduli/ModuliList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/moduli/read/:id",
    name: "modules-read",
    component: () => import("./views/module/moduli/ModuliRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/moduli/update/:id",
    name: "modules-update",
    component: () => import("./views/module/moduli/ModuliUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ruoli",
    name: "roles",
    component: () => import("./views/module/ruoli/RuoliList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ruoli/create",
    name: "roles-create",
    component: () => import("./views/module/ruoli/RuoliCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ruoli/read/:id",
    name: "roles-read",
    component: () => import("./views/module/ruoli/RuoliRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ruoli/update/:id",
    name: "roles-update",
    component: () => import("./views/module/ruoli/RuoliUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/utenti",
    name: "users",
    component: () => import("./views/module/utenti/UtentiList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/utenti/create",
    name: "users-create",
    component: () => import("./views/module/utenti/UtentiCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/utenti/read/:id",
    name: "users-read",
    component: () => import("./views/module/utenti/UtentiRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/utenti/update/:id",
    name: "users-update",
    component: () => import("./views/module/utenti/UtentiUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rapporti",
    name: "rapporti",
    component: () => import("./views/module/rapporti/RapportoList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rapporti/read/:id",
    name: "rapporti-read",
    component: () => import("./views/module/rapporti/RapportoRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rapporti/update/:id",
    name: "rapporti-update",
    component: () => import("./views/module/rapporti/RapportoUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rapporti/create",
    name: "rapporti-create",
    component: () => import("./views/module/rapporti/RapportoCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/rapporti/import",
    name: "rapporti-import",
    component: () => import("./views/module/rapporti/RapportoImport"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/permessi",
    name: "permessi",
    component: () => import("./views/module/permessi/PermessiList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/permessi/read/:id",
    name: "permessi-read",
    component: () => import("./views/module/permessi/PermessiRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/permessi/update/:id",
    name: "permessi-update",
    component: () => import("./views/module/permessi/PermessiUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/permessi/create",
    name: "permessi-create",
    component: () => import("./views/module/permessi/PermessiCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/interventi",
    name: "interventi",
    component: () => import("./views/module/interventi/InterventiList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/interventi/read/:id",
    name: "interventi-read",
    component: () => import("./views/module/interventi/InterventiRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/interventi/update/:id",
    name: "interventi-update",
    component: () => import("./views/module/interventi/InterventiUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/interventi/create",
    name: "interventi-create",
    component: () => import("./views/module/interventi/InterventiCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/riepilogo",
    name: "riepilogo",
    component: () => import("./views/module/riepilogo/RiepilogoCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/movimenti",
    name: "movements",
    component: () => import("./views/module/movimenti/MovimentiList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/movimenti/create",
    name: "movements-create",
    component: () => import("./views/module/movimenti/MovimentiCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/movimenti/read/:id",
    name: "movements-read",
    component: () => import("./views/module/movimenti/MovimentiRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/movimenti/update/:id",
    name: "movements-update",
    component: () => import("./views/module/movimenti/MovimentiUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/aziende",
    name: "company",
    component: () => import("./views/module/aziende/AziendeList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/aziende/create",
    name: "company-create",
    component: () => import("./views/module/aziende/AziendeCreate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/aziende/read/:id",
    name: "company-read",
    component: () => import("./views/module/aziende/AziendeRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/aziende/update/:id",
    name: "company-update",
    component: () => import("./views/module/aziende/AziendeUpdate"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/ddt",
    name: "ddt",
    component: () => import("./views/module/ddt/DdtList"),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/ddt/create",
  //   name: "ddt-create",
  //   component: () => import("./views/module/ddt/DdtCreate"),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: "/ddt/read/:id",
    name: "ddt-read",
    component: () => import("./components/DdtView"),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/ddt/update/:id",
  //   name: "ddt-update",
  //   component: () => import("./views/module/ddt/DdtUpdate"),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: "/file/:id",
    name: "file-read",
    component: () => import("./views/module/rapporti/FileRead"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("./views/PageHome"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

async function getCurrentUser(to) {
  let token = localStorage.getItem("token");
  let user = localStorage.getItem("user");

  if (String(token) !== 'null') {
    let res = false;
    let configH = getHeaders();
    await axios.post(baseURL + 'auth/session', { session: md5(user + token), direction: to }, configH)
      .then(response => {
        if (response) {
          if (response.data) {
            if (response.data.data.code === 200) {
              res = true;
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
    if (res) {
      return res;
    }
  }

  localStorage.clear();
  return false;
}

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (await getCurrentUser(to.name)) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
